import moment from "moment";
import {LocaleDictionaryBasic} from "../../interface/basic";

export const basic: LocaleDictionaryBasic = {
    delete : 'Delete',
    reply : 'Reply',
    send : 'Send',
    cancel : 'Cancel',
    continue : 'Continue',
    groups : 'Groups',
    group : 'Group',
    confirm : 'Confirm',
    save : 'Save',
    day1 : 'Business day',
    day2 : 'Business days',
    day3 : 'Business days',
    notSelected : 'Not selected',
    notSelected2 : 'Not selected',
    notSelected3 : 'Not selected',
    today : 'Today',
    download : 'Download',
    footer : '© 2006-' + moment().format('YYYY') + ' Все права защищены «Российский университет дружбы народов»',
    error404 : 'Такой страницы нет',
    error404Text : 'Ссылка, по которой Вы перешли, никуда не ведёт. Вероятно, это произошло из-за опечатки в адресе или эта страница была удалена.',
    error : 'Ошибка',
    errorNoProfile : 'Ваша учётная запись не найдена. Обратитесь в единую службу технической поддержки РУДН',
    phone : 'Телефон',
    email : 'Email',
    details : 'Details',
    noResult : 'По Вашему запросу ничего не найдено'
};